export const ENUM = {
  PADOONGRICH: 'PADOONGRICH',
  TRANSPORT: 'TRANSPORT',
}

export default {
  PADOONGRICH: 'บริษัท ผดุงฤทธิ์ขนส่ง จำกัด',
  TRANSPORT: 'บริษัท ทรานสปอร์ตเตชั่น เน็ตเวิร์ค จำกัด',
}
